var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incidents",style:(_vm.style)},_vm._l((_vm.items),function(i){return _c('div',{staticClass:"item",style:(i.style)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }